export const SHOP_URL = "https://shop.natespharmacy.com/";
